import { Analysis } from '.';

export class BoneMarrowAnalysis extends Analysis {
    boneMarrowOverproductionIsLikely?: boolean;

    reset() {
        super.reset()
        this.boneMarrowOverproductionIsLikely = false;
    }

    performAnalysis() {
        super.performAnalysis()
        // WBC >= Opt AND 
        // RBC > Lab AND 
        // HGB > Lab AND 
        // HCT > Lab AND
        // MCV <= Opt AND 
        // MCH <= Opt AND 
        // MCHC <= Opt AND 
        // platelets >= Opt AND
        // neutrophilsAbs >= Opt AND
        // eosinophilsAbs >= Opt AND 
        // basophilsAbs >= Opt AND 
        // biliburin > Opt AND 
        // alkalinePhosphatase > Opt AND
        // iron <= Opt
        if (this.ba.wbc.isGreaterThanOrIsOptimal() && 
            this.ba.rbc.isGreaterThanLab() && 
            this.ba.hgb.isGreaterThanLab() && 
            this.ba.hct.isGreaterThanLab() &&
            this.ba.mcv.isLessThanOrIsOptimal() && 
            this.ba.mch.isLessThanOrIsOptimal() && 
            this.ba.mchc.isLessThanOrIsOptimal() &&
            this.ba.platelets.isGreaterThanOrIsOptimal() &&
            this.ba.neutrophilsAbs.isGreaterThanOrIsOptimal() &&
            this.ba.eosinophilsAbs.isGreaterThanOrIsOptimal() &&
            this.ba.basophilsAbs.isGreaterThanOrIsOptimal() &&
            this.ba.bilirubin.isGreaterThanOptimal() &&
            this.ba.alp.isGreaterThanOptimal() &&
            this.ba.iron.isLessThanOrIsOptimal()
        ) {
            this.boneMarrowOverproductionIsLikely = true;
        }
    }

    calculateInsights() {
        // Nothing to do for this one here
    }
}